import React from 'react'
import { useForm } from 'react-final-form'
import useLookupService from '../../../../services/lookup/useLookupService'
import * as defineDirectorTypes from './defineDirectorTypes'
import useTranslate from '../../../../i18n/useTranslate'
import useLoading from '../../../../control/loading/useLoading'
import useAuthenStore from '../../../../stores/authen/authenStore'
import useWebService from '../../../../services/web/useWebService'
import { validateModeAccordionError } from '../../../../utilities/validate'
import useFolderAndTab from '../../project/useFolderAndTab'
import useCheckPermission from '../../../../utilities/checkPermission'

const useDefineDirector = (props: defineDirectorTypes.UseDefineDirectorType) => {
    const { irb, irbType, reqField = true, projectData } = props
    const translate = useTranslate()
    const callLookup = useLookupService()
    const loadingHook = useLoading()
    const authenStore = useAuthenStore()
    const webServiceHook = useWebService()
    const [director, setDirector] = React.useState<defineDirectorTypes.OptType[]>([])
    const [role, setRole] = React.useState<defineDirectorTypes.OptType[]>([])
    const [isError, setIsError] = React.useState<boolean>(false)
    const [reqFieldForm, setReqFieldForm] = React.useState<[{ director: boolean; role: boolean }]>([
        { director: reqField, role: reqField },
    ])
    const committee = React.useRef<{ director: any; role: any }[]>([])
    const directorRef = React.useRef<any[]>([])
    const form = useForm()
    const listTopicCommittee: string[] = []
    const folderAndTabHook = useFolderAndTab()
    const checkPermission = useCheckPermission()

    React.useEffect(() => {
        if (irb) {
            getDirector(irb)
        }

        getRole()
        conditionRequiredField()
    }, [irb, translate.languageStore.currentLanguage, reqField])

    React.useEffect(() => {
        if (projectData && projectData?.committeeInfo.length > 0) {
            directorRef.current = projectData?.committeeInfo.map((itm: any, idx: number) => {
                return { index: idx, value: itm.userID?.toString() }
            })
        }
    }, [projectData?.committeeInfo ?? null])

    const getDirector = async (irb: number) => {
        const res = await callLookup.callDirectorNameLut(irb)
        const formatData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
                disabled: false,
            }
        })
        setDirector(formatData)
    }
    const getRole = async () => {
        if (irb) {
            const res = await callLookup.callRoleLut(irb)
            const formatData = res.result.map((itm) => {
                return {
                    label:
                        translate.languageStore.currentLanguage === translate.languageKey.th
                            ? itm.name_th
                            : itm.name_en,
                    value: `${itm.id}`,
                }
            })
            setRole(formatData)
        }
    }

    const conditionRequiredField = () => {
        const isCommittee: defineDirectorTypes.CommitteeType[] | undefined = form.getState().values.committeeInfo
        if (isCommittee) {
            //เข้าก็ต่อเมื่อ มีการกำหนดกรรมการแล้ว
            isCommittee.forEach((itm, index: number) => {
                if (reqFieldForm[index]) {
                    if (!reqField) {
                        //เข้าก็ต่อเมื่อเลือกประเภทโครงการเป็น exempt

                        if (itm.director && !itm.role) {
                            //เข้าก็ต่อเมื่อ มีการเลือกกรรมการแต่ไม่ได้เลือกหน้าที่
                            reqFieldForm[index].director = false
                            reqFieldForm[index].role = true
                        } else if (!itm.director && itm.role) {
                            //เข้าก็ต่อเมื่อ มีการเลือกหน้าที่แต่ไม่ได้เลือกกรรมการ
                            reqFieldForm[index].director = true
                            reqFieldForm[index].role = false
                        } else {
                            reqFieldForm[index].director = false
                            reqFieldForm[index].role = false
                        }
                    } else {
                        //เข้าก็ต่อเมื่อไม่ได้เลือกประเภทโครงการเป็น exempt
                        reqFieldForm[index].director = true
                        reqFieldForm[index].role = true
                    }
                }
            })
        } else {
            //ยังไม่เคยกำหนดกรรมการ
            setReqFieldForm([{ director: reqField, role: reqField }])
        }
    }

    const handleClickAdd = (field: any) => {
        const isEmpty = field?.value?.find(
            (e: { director: defineDirectorTypes.OptType; role: defineDirectorTypes.OptType }) =>
                !e?.director || !e?.role,
        )
        if (!isEmpty) {
            setIsError(false)
            reqFieldForm?.push({ director: reqField, role: reqField })
            field.push({})
            committee.current?.push({ director: null, role: null })
        } else {
            setIsError(true)
        }
    }

    const handleClickRemove = (field: any, index: number) => {
        const newField = field.remove(index)

        const filterCommittee = field?.value.filter((itm: any) => {
            return itm !== newField
        })

        directorRef.current = filterCommittee?.map(
            (item: { director: defineDirectorTypes.OptType; role: defineDirectorTypes.OptType }, idx: number) => {
                return { index: idx, value: item?.director?.value }
            },
        )

        //@ts-ignore
        committee.current = committee.current?.filter((itm, idex) => {
            return idex !== index
        })
    }

    const validateField = (value: defineDirectorTypes.OptType, index: number, lengthFields: number) => {
        if (value) {
            return false
        } else {
            if (lengthFields === index) {
                return isError
            } else {
                return false
            }
        }
    }

    const handleChangValDirector = (val: defineDirectorTypes.OptType, index: number) => {
        if (directorRef.current.length > 0) {
            const isDuplicateIdx = directorRef.current.find((e: { index: number; value: string }) => e.index === index)

            if (!isDuplicateIdx) {
                directorRef.current = [...directorRef.current, { index: index, value: val.value }]
            } else {
                directorRef.current = directorRef.current.map((itm: any) => {
                    if (itm.index === index) {
                        return {
                            ...itm,
                            value: val?.value ? val?.value : null,
                        }
                    } else {
                        return itm
                    }
                })
            }
        } else {
            directorRef.current = [{ index: index, value: val.value }]
        }

        if (!reqField) conditionReqFieldDirector(val, index)

        // if (!reqField && irbType !== 2) conditionReqFieldDirector(val, index)

        if (irbType === 2) {
            conditionIRB2(val, index)
        }
    }

    const handleChangValRole = (val: defineDirectorTypes.OptType, index: number) => {
        if (!reqField) conditionReqFieldRole(val, index)

        // if (irbType === 2) {
        //     conditionIRB2(val, index)
        // }
    }

    const handleOpen = (index: number) => {
        // set opt director enable all
        director.map((item: any) => {
            return (item.disabled = false)
        })

        // set opt disable when opt selected
        director.forEach((itm: any) => {
            directorRef.current.forEach((item: any) => {
                if (index === item.index && item.value === itm.value) {
                    // เปิด disable กรรมการใน index ที่เปิด
                    itm.disabled = false
                } else if (item.value === itm.value) {
                    itm.disabled = true
                }
            })
        })
    }

    const conditionReqFieldDirector = (val: defineDirectorTypes.OptType, index: number) => {
        const committeeInfo = form.getState().values?.committeeInfo
        if (!val && !reqField) {
            setIsError(false)
            if (committeeInfo[index].role) {
                reqFieldForm[index].director = true
            } else {
                reqFieldForm[index].role = reqField
            }
        }
        if (val && !reqField) {
            reqFieldForm[index].director = reqField
            committeeInfo.forEach(
                (item: { director: defineDirectorTypes.OptType; role: defineDirectorTypes.OptType }, idx: number) => {
                    if (!item.role) reqFieldForm[idx].role = !reqField
                },
            )
        }
        form.restart()
    }

    const conditionReqFieldRole = (val: defineDirectorTypes.OptType, index: number) => {
        const committeeInfo = form.getState().values?.committeeInfo
        if (!val && !reqField) {
            setIsError(false)
            if (committeeInfo[index].director) {
                reqFieldForm[index].role = true
            } else {
                reqFieldForm[index].director = reqField
            }
        }

        if (val && !reqField) {
            reqFieldForm[index].role = reqField
            committeeInfo.forEach(
                (item: { director: defineDirectorTypes.OptType; role: defineDirectorTypes.OptType }, idx: number) => {
                    if (!item.director) reqFieldForm[idx].director = !reqField
                },
            )
        }
        form.restart()
    }

    const conditionIRB2 = (value: defineDirectorTypes.OptType, index: number) => {
        const role = value ? { label: 'ผู้ทบทวนหลัก', value: '1' } : null

        committee.current = form.getState().values?.committeeInfo

        if (committee.current) {
            if (index < committee.current.length) {
                const formatedData = committee.current.map((itm: any, idx: number) => {
                    if (idx === index) {
                        return {
                            director: value,
                            role: role,
                        }
                    } else {
                        return { ...itm }
                    }
                })
                //@ts-ignore
                committee.current = formatedData
            } else {
                //*เข้า else ก็ต่อเมื่อมีการเพิ่มกรรมการคนที่ 2 ขึ้นไป */
                const newData = { director: value, role: role }
                committee.current.push(newData)
            }

            form.change('committeeInfo', committee.current)
        } else {
            committee.current = [{ director: value, role: role }]
            form.change('committeeInfo', committee.current)
        }
    }

    const handleSubmitOfficerEdit = (fieldNames: string[]) => {
        const isError = validateModeAccordionError(fieldNames, form.getState())
        return new Promise((resolve, reject) => {
            const param = createParamCommitteeUpdate()
            if (isError) {
                reject('')
            } else {
                loadingHook.loadingOpen()

                processUpdate(param)
                    .then(() => {
                        folderAndTabHook.reloadProjectData()
                        resolve('')
                    })
                    .catch(() => {
                        reject('')
                    })
                    .finally(() => {
                        loadingHook.loadingClose()
                    })
            }
        })
    }

    const createParamCommitteeUpdate = () => {
        const formValue = form.getState().values
        let param = {
            loginUserID: authenStore.profile.userId,
            projectID: projectData?.projectID,
            submittedID: projectData?.submittedID,
            committeeInfo: formValue?.committeeInfo?.map((item: any) => {
                return {
                    submittedID: projectData?.submittedID,
                    committeeID: item.director.value,
                    projectRoleID: item.role.value,
                }
            }),
        }
        return param
    }

    const processUpdate = async (param: any) => {
        await webServiceHook.updSubmittedCommittee(param)
    }

    const onClickEdit = () => {
        committee.current = form.getState().values?.committeeInfo
    }

    const listCommittee = committee.current?.reduce((accumulator: string[], item, index: number) => {
        accumulator.push(`committeeInfo[${index}].director`, `committeeInfo[${index}].role`)
        listTopicCommittee.push(`committeeInfo[${index}]`)
        return accumulator
    }, [])

    const handleCancle = () => {
        listTopicCommittee?.forEach((key, index) => {
            form.change(key, committee.current[index])
        })
    }
    return {
        isError,
        role,
        director,
        reqFieldForm,
        onClickRemove: handleClickRemove,
        onClickAdd: handleClickAdd,
        validateField,
        onChangValDirector: handleChangValDirector,
        onChangValRole: handleChangValRole,
        onOpenOpt: handleOpen,
        useModeAccordion: checkPermission.isAllowDefineDirector(projectData),
        handleSubmitOfficerEdit,
        onClickEdit,
        listCommittee,
        handleCancle,
    }
}

export default useDefineDirector
